import { FbObjectCellRendererClass } from '../cells/FbObjectCellRendererClass';
import { FbObjectCellEditorClass } from '../cells/FbObjectCellEditorClass';

export default function objectCellService({ FbCellRenderer, FbCellEditor, TYPES: { object } }) {
  const objectService = object(); // importación servicio angular

  return function generate(viewField, engineApi, engineGridApi) {
    const column = engineApi.cell.setCommonAttributes(viewField, engineApi, engineGridApi);

    column.type = 'object';
    column.icon = 'bars';

    // fullscreen
    if (viewField.metadata.fullscreen) {
      column.fullscreen = true;
      column.icon = 'up-right-and-down-left-from-center';
    }

    // creamos las opciones del popup:
    const renderPopup = renderPopupFactory();
    const valueToString = engineApi.register.toString(viewField, engineApi);
    const renderCell = ({ value }) => {
      return valueToString(value);
    };

    // renderer
    column.renderer = FbObjectCellRendererClass(FbCellRenderer, {}, { renderPopup, valueToString });

    // editor
    column.editor = FbObjectCellEditorClass(FbCellEditor, {}, { renderPopup, renderCell });

    return column;

    function renderPopupFactory() {
      const template = objectService(viewField, engineApi).toString();
      // renderPopup es una función que devuelve el template fijo en este caso.
      return () => {
        return template;
      };
    }
  };
}
